import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import Navbar from "../../../components/NavbarAdmin.js";
import Select from "react-select";
import {
    tokens,
    select_style,
    GET,
    POST,
    PUT,
    DELETE,
    validate,
    required,
    success_url,
    NumberZero
} from "../../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';
import { Modal } from "react-bootstrap";

export default class ListModel extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modal_create: false,
            modal_update: false,
            modal_delete: false,

            page: 1,
            loading: false,

            filter_search: "",

            data: null,
            data_brand: [],

            id: "",
            brand_id: "",
            model_name: "",
            model_description: "",
            is_active: true

        }
    }
    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetAll();
        await this.GetBrandAll();
        this.setState({ loading: false });
    }

    GetBrandAll = async () => {
        let data = {
            data_search: "",
        }
        let result = await GET(tokens, "v1/TH/bike-brand/filter-search/page/0", data);
        if (result && result.status) {
            this.setState({ data_brand: result.data.data.map(item => { return { label: item.brand_name, value: item.brand_id } }) })
        }
    }
    GetAll = async () => {
        let data = {
            data_search: this.state.filter_search,
        }
        let result = await GET(tokens, "v1/TH/bike-model/filter-search/page/" + this.state.page, data);
        if (result && result.status) {
            this.setState({ data: result.data })
        }
    }
    Create = async () => {
        if (validate(this.state, ["brand_id", "model_name"])) { return };
        this.setState({ loading: true });
        let data = {
            brand_id: this.state.brand_id ? this.state.brand_id.value : "",
            model_name: this.state.model_name,
            model_description: this.state.model_description,
        }
        let result = await POST(tokens, "v1/TH/bike-model/create", data);
        if (result && result.status) {
            success_url("/master/list-model")
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (validate(this.state, ["brand_id", "model_name"])) { return };
        this.setState({ loading: true });
        let data = {
            model_id: this.state.id,
            brand_id: this.state.brand_id ? this.state.brand_id.value : "",
            model_name: this.state.model_name,
            model_description: this.state.model_description,
            is_active: this.state.is_active
        }
        let result = await PUT(tokens, "v1/TH/bike-model/update", data);
        if (result && result.status) {
            success_url("/master/list-model")
        }
        this.setState({ loading: false });
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, 'v1/TH/bike-model/delete/' + this.state.id, null);
        if (result && result.status) {
            success_url("/master/list-model")
        }
        this.setState({ loading: false });
    }
    handlePageChange(pageNumber) {
        this.setState({ page: pageNumber })
        setTimeout(() => { this.GetAll() }, 10)
    }
    clear_form() {
        this.setState({
            modal_create: false,
            modal_update: false,
            modal_delete: false,

            page: 1,
            loading: false,

            filter_search: "",

            id: "",
            brand_id: "",
            model_name: "",
            model_description: "",
            is_active: true

        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="รุ่นรถ" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h4 className="mb-3"><b>รุ่นรถ</b></h4>
                            <div className="d-flex">
                                <button type="button" className="btn btn-outline-orange px-4 mx-1 mb-3" onClick={() => { window.location.href = "/admin/master" }}>
                                    <label className="icon mr-2" > {"\uf060"} </label>
                                    ย้อนกลับ
                                </button>
                                <button type="button" className="btn btn-orange px-4 mx-1 mb-3 add" onClick={() => { this.clear_form(); this.setState({ modal_create: true }) }}>
                                    เพิ่มรุ่นรถ
                                </button>
                            </div>
                        </div>
                        <div className="card border-0">
                            <div className="card-header bg-contain pb-0 view">
                                {/* ค้นหาและตัวกรอง */}
                                <div className="d-flex row mx-0">
                                    {/* ค้นหา */}
                                    <input
                                        type="search"
                                        className="form-control bg-white wpx-200 border-0 mx-1 mb-2"
                                        placeholder="ยี่ห้อ,รุ่น"
                                        onChange={(e) => { this.setState({ filter_search: e.target.value }); }}
                                        onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                                this.setState({ page: 1 })
                                                setTimeout(() => {
                                                    this.GetAll();
                                                }, 1);
                                            }
                                        }}
                                        onBlur={() => {
                                            this.setState({ page: 1 })
                                            setTimeout(() => {
                                                this.GetAll();
                                            }, 1);
                                        }}
                                        value={this.state.filter_search}
                                    />
                                    {/* ค้นหา */}
                                    <button className="btn btn-orange px-3 mb-2 mx-1" onClick={() => {
                                        this.setState({ page: 1 });
                                        setTimeout(() => {
                                            this.GetAll();
                                        }, 1);
                                    }}>ค้นหา</button>
                                    {/* รีเซ็ท */}
                                    <button className="btn btn-outline-orange px-3 mb-2 mx-1"
                                        onClick={() => {
                                            this.setState({
                                                filter_search: "",
                                                page: 1
                                            });
                                            setTimeout(() => {
                                                this.GetAll();
                                            }, 1);
                                        }}>รีเซ็ท</button>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                {/* ตาราง */}
                                <div className="table-responsive">
                                    <table className="table table-borderless table-striped">
                                        <thead>
                                            <tr>
                                                <th className="text-center">ลำดับ</th>
                                                <th className="text-center">ยี่ห้อ</th>
                                                <th className="text-center">รุ่น</th>
                                                <th className="text-center">คำอธิบาย</th>
                                                <th className="text-center">จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(!this.state.data || this.state.data.length === 0) && (
                                                <tr> <td colSpan={5} className="text-center"> ไม่มีข้อมูล </td> </tr>
                                            )}
                                            {this.state.data && this.state.data.data.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{NumberZero(((this.state.page - 1) * 10) + index + 1, 5)}</td>
                                                    <td className="text-center">{item.model_data ? item.brand_name : "-"}</td>
                                                    <td className="text-center">{item.model_data ? item.model_data.model_name : "-"}</td>
                                                    <td className="text-center">{item.model_data ? item.model_data.model_description : "-"}</td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center">
                                                            <label className="wpx-30 hpx-30 bg-warning-light pointer rounded-1 d-flex align-items-center justify-content-center mx-1 edit"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        modal_update: true,
                                                                        id: item.model_data.model_id,
                                                                        brand_id: this.state.data_brand.filter(e => e.value === item.brand_id)[0],
                                                                        model_name: item.model_data.model_name,
                                                                        model_description: item.model_data.model_description,
                                                                        is_active: item.model_data.is_active,
                                                                    })
                                                                }}>
                                                                <label
                                                                    className="icon mx-2 text-warning pointer"
                                                                > {"\uf304"} </label>
                                                            </label>
                                                            <label className="wpx-30 hpx-30 bg-danger-light pointer rounded-1 d-flex align-items-center justify-content-center mx-1 delete"
                                                                onClick={() => { this.setState({ modal_delete: true, id: item.model_data.model_id, }) }}>
                                                                <label
                                                                    className="icon mx-2 text-danger pointer"
                                                                > {"\uf1f8"} </label>
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {/* pagination */}
                        {this.state.data && this.state.data.data.length !== 0 && (
                            <div className="d-flex justify-content-between row mx-0 w-100 px-3 mt-3">
                                <div><label> แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ </label></div>
                                <Pagination count={this.state.data.page_number} page={this.state.page} color="warning" showFirstButton shape="rounded" showLastButton onChange={(event, value) => { this.handlePageChange(value) }} />
                            </div>
                        )}
                    </div>
                </div>
                {/* MODAL */}

                {/* create or update */}
                <Modal
                    show={this.state.modal_create || this.state.modal_update}
                    onHide={() => { this.setState({ modal_create: false, modal_update: false }) }}
                >
                    <Modal.Header> <Modal.Title> <b>{this.state.modal_create ? "เพิ่มรุ่นรถ" : "แก้ไขรุ่นรถ"}</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        {/* ยี่ห้อ */}
                        <div className="w-100 d-flex align-items-center mb-3">
                            <label className="wpx-140">ยี่ห้อ{required}:</label>
                            <Select
                                className="form-control  validate select-search"
                                styles={select_style}
                                options={this.state.data_brand}
                                onChange={(e) => {
                                    this.setState({ brand_id: e });
                                }}
                                value={this.state.brand_id}
                            ></Select>
                        </div>
                        {/* ปุ่ม */}
                        {/* ชื่อรุ่น */}
                        <div className="w-100 d-flex align-items-center mb-3">
                            <label className="wpx-140">ชื่อรุ่น{required}:</label>
                            <input
                                className="form-control  validate"
                                type="text"
                                placeholder="กรอกข้อมูล"
                                onChange={(e) => {
                                    this.setState({ model_name: e.target.value })
                                }}
                                value={this.state.model_name}
                            />
                        </div>
                        {/* คำอธิบาย */}
                        <div className="w-100 d-flex align-items-center mb-3">
                            <label className="wpx-140">คำอธิบาย :</label>
                            <textarea
                                className="form-control  validate"
                                type="text"
                                placeholder="กรอกข้อมูล"
                                onChange={(e) => {
                                    this.setState({ model_description: e.target.value })
                                }}
                                value={this.state.model_description}
                            />
                        </div>
                        <div className="w-100 d-flex">
                            <div className="w-50 p-1">
                                <button
                                    className="btn btn-outline-orange w-100"
                                    onClick={() => {
                                        this.setState({ modal_create: false, modal_update: false })
                                    }}
                                >
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 p-1">
                                <button
                                    className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create) {
                                            this.Create();
                                        } else {
                                            this.Update();
                                        }
                                    }}
                                >
                                    {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                {/* delete */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header><Modal.Title><b>ยืนยันการลบข้อมูล</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="w-100 d-flex mb-3">
                            <label>
                                คุณแน่ใจว่าต้องการลบข้อมูลดังกล่าว
                                เมื่อยืนยันแล้วจะไม่สามารถย้อนคือข้อมูลได้
                            </label>
                        </div>
                        <div className="w-100 d-flex">
                            <div className="w-50 p-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 p-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ยืนยัน
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div >
        )
    }
}
